import script from "./ViewAddStanding.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAddStanding.vue?vue&type=script&setup=true&lang=js"

import "./ViewAddStanding.vue?vue&type=style&index=0&id=f1a275b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1a275b2"]])

export default __exports__